// The products a day points at. `days` hold ids, the two maps hold the products.
export const getDayExperience = (day: any, experiencesMap: any) =>
  day?.experienceId ? experiencesMap?.[day.experienceId] : null;

export const getDayHotel = (day: any, hotelsMap: any) =>
  day?.hotelId ? hotelsMap?.[day.hotelId] : null;
